import { render } from "./RemovePrepayOrder.vue?vue&type=template&id=0c544962&scoped=true"
import script from "./RemovePrepayOrder.vue?vue&type=script&lang=js"
export * from "./RemovePrepayOrder.vue?vue&type=script&lang=js"

import "./RemovePrepayOrder.vue?vue&type=style&index=0&id=0c544962&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c544962"]])

export default __exports__